<template>
  <div data-testid="contractual-reporting-page">
    <div class="card">
        <div class="card-header">
            <div class="row">
                <div class="col-md-6">
                    <b>Generování dávek</b>
                </div>
                <div class="col-md-6">
                </div>
            </div>
        </div>
        <div class="card-header">
            <div class="row">
                <div class="col-md-2">
                  Měsíc pro generování dávky <datepicker v-model="selectedDate" placeholder="vybrat datum" format="dd.MM.yyyy" language="cs" :monday-first="true" :full-month-name="true" name="validFrom" input-class="datapickerInput" data-testid="contractual-reporting-month"></datepicker>
                </div>
                <div class="col-md-2">
                  Filtr. pojišťovny
                  <input class="form-control" v-model="generateParams.filter_insurance_company_code" type="text" placeholder="Filtrované pojišťovny" data-testid="contractual-reporting-insurance-filter">
                </div>
                <div class="col-md-2">
                  Vyřazené diagnózy
                  <input class="form-control" v-model="generateParams.exclude_diagnosis_code" type="text" placeholder="Vyřazené diagnózy" data-testid="contractual-reporting-excluded-diagnoses">
                </div>
                <div class="col-md-2">
                  Filtr. diagnózy
                  <input class="form-control" v-model="generateParams.filter_diagnosis_code" type="text" placeholder="Filtrované diagnózy" data-testid="contractual-reporting-diagnosis-filter">
                </div>
                <div class="form-check col-md-1">
                    <input v-model="generateParams.repair" class="form-check-input" type="checkbox" value="" id="repair" data-testid="contractual-reporting-repair">
                    <label class="form-check-label" for="repair">
                      Opravné
                    </label>
                </div>
                <div class="form-check col-md-1">
                    <input v-model="generateParams.dry" class="form-check-input" type="checkbox" value="" id="test" data-testid="contractual-reporting-dry-run">
                    <label class="form-check-label" for="test">
                      Test
                    </label>
                </div>
              <div class="col-md-6">
                Filtr. návštěvy dle id
                <input class="form-control" v-model="generateParams.filter_visit_id" type="text" placeholder="Filtrované návštěvy" data-testid="contractual-reporting-visit-filter">
              </div>
              <div class="col-md-6">
                Filtr. klientů dle id
                <input class="form-control" v-model="generateParams.filter_clients" type="text" placeholder="Filtrovaní klienty" data-testid="contractual-reporting-client-filter">
              </div>
            </div>
          <div class="row mt-4 justify-content-end">
            <div class="col-md-1 text-right">
              <button @click="generate()" class="btn btn-secondary btn-sm" data-testid="contractual-reporting-generate">Generovat</button>
            </div>
          </div>
        </div>
        <div class="card-body" v-if="generateContractualReportsPending">
          <div class="text-center">
            <i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i><br/>
            (generuji)
          </div>
        </div>
      <div class="card-body" v-if="generateContractualReports !== null" data-testid="contractual-reporting-generated">
        <table class="table">
          <thead>
          <tr class="row m-0">
            <th class="col-sm-1">Pojišťovna</th>
            <th class="col-sm-1">Typ</th>
            <th class="col-sm-1">Charakter</th>
            <th class="col-sm-2">Počet bodů</th>
            <th class="col-sm-2">Cena</th>
            <th class="col-sm-2">Kód souboru</th>
            <th class="col-sm-1"></th>
          </tr>
          </thead>
          <tbody>
          <template v-for="(cr, index) in generateContractualReports" class="card-text">
              <tr class="row m-0">
                <td class="col-sm-1">
                  {{ cr.insurance_company_code }}
                </td>
                <td class="col-sm-1">
                  {{ cr.insurance_type_code }}
                </td>
                <td class="col-sm-1">
                  {{ cr.repair ? 'O' : 'P' }}
                </td>
                <td class="col-sm-2">
                  {{ cr.points }}
                </td>
                <td class="col-sm-2">
                  {{ cr.price }}
                </td>
                <td class="col-sm-2">
                  {{ cr.number }}
                </td>
              </tr>
          </template>
          </tbody>
        </table>
      </div>
    </div>
    <div class="card">
        <div class="card-header">
          <div class="row">
            <div class="col-md-6">
              <b>Přehled dříve vygenerovaných dávek</b>
            </div>
            <div class="col-md-6 text-right">
                <button @click="getDoctorsDayTasks()" class="btn btn-secondary btn-sm"><i class="fa fa-refresh"></i></button>
            </div>
          </div>
        </div>
        <div class="card-body" v-if="listData.length > 0" data-testid="contractual-reporting-list">
          <a :href="hostname.hostname + 'contractual_reports/file_zip?ids=' + selectedIds.toString()" target="_blank" class="btn btn-sm btn-success" role="button" v-if="selectedIds.length > 0"><i class="fa fa-archive"></i> Stáhnout zazipované</a>
          <a class="btn btn-sm btn-success disabled" role="button" disabled="disabled" v-else=""><i class="fa fa-archive"></i> Stáhnout zazipované</a>
          <table class="table">
                <thead>
                <tr class="row m-0">
                    <th class="col-sm-1"></th>
                    <th class="col-sm-1">Pojišťovna</th>
                    <th class="col-sm-1">Typ</th>
                    <th class="col-sm-1">Charakter</th>
                    <th class="col-sm-2">Vygenerováno</th>
                    <th class="col-sm-2">Počet bodů</th>
                    <th class="col-sm-2">Cena</th>
                    <th class="col-sm-1">Kód souboru</th>
                    <th class="col-sm-1"></th>
                </tr>
                </thead>
                <tbody>
                <template v-for="(cr, index) in listData" class="card-text">
                    <tr class="row m-0" :data-testid="'contractual-reporting-row-' + cr.id">
                        <td class="col-sm-1">
                            <input class="form-check-input" type="checkbox" v-model="selectedIds" :value="cr.id" :data-testid="'contractual-reporting-select-' + cr.id">
                        </td>
                        <td class="col-sm-1" :title="cr.insurance_company.name">
                          {{ cr.insurance_company.code }}
                        </td>
                        <td class="col-sm-1" :title="cr.insurance_type.name">
                          {{ cr.insurance_type.code }}
                        </td>
                        <td class="col-sm-1" :title="cr.repair ? 'Opravná' : 'Původní'">
                          {{ cr.repair ? 'O' : 'P' }}
                        </td>
                        <td class="col-sm-2">
                          {{ $moment(cr.created_at, 'DD.MM.YYYY H:mm').format('DD.MM.YYYY HH:mm') }}
                        </td>
                        <td class="col-sm-2">
                          {{ cr.points }}
                        </td>
                        <td class="col-sm-2">
                          {{ cr.price }}
                        </td>
                        <td class="col-sm-1">
                          {{ cr.number }}
                        </td>
                        <td class="col-sm-1">
                          <a class="btn btn-sm btn-primary" target="_blank" role="button" :href="hostname.hostname + 'contractual_reports/' + cr.id + '/file'"><i class="fa fa-download"></i></a>
                          <button class="btn btn-sm btn-danger" v-if="!deleteContractualReportPending" @click="deleteContractualReport(cr.id)" :data-testid="'contractual-reporting-delete-' + cr.id"><i class="fa fa-trash-o"></i></button>
                          <button class="btn btn-sm btn-danger disabled" disabled="disabled" v-else=""><i class="fa fa-trash-o"></i></button>
                        </td>
                    </tr>
                </template>
                </tbody>
            </table>
            <pagination-component :list-pagination="listPagination" @set-page="setPage"/>
        </div>
        <div class="card-body" v-else-if="listPending">
            <div class="text-center">
                    <i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i><br/>
                    (načítám)
            </div>
        </div>
        <div class="card-body" v-else="">
            <div class="text-center">
                <i class="fa fa-frown-o fa-3x"></i><br/>
                (nebyl nalezen žádný výsledek dle požadavků)
            </div>
        </div>
    </div>
  </div>
</template>

<script>
  import apiMixin from '@/mixins'
  import PaginationComponent from '../../../components/PaginationComponent.vue'

  export default {
    data () {
      return {
        generateParams: {
          date: null,
          filter_insurance_company_code: '111,201,205,207,209,211,213',
          exclude_diagnosis_code: 'X3720',
          filter_diagnosis_code: '',
          filter_visit_id: '',
          filter_clients: '',
          repair: false,
          dry: true
        },
        selectedDate: null,
        hostname: require('@/variables.js'),
        generateContractualReportsPending: false,
        generateContractualReportsDone: false,
        generateContractualReports: null,
        generateContractualReportsError: false,
        // DELETE request
        deleteContractualReportPending: false,
        deleteContractualReportDone: false,
        deleteContractualReportError: false,
        selectedIds: [],
        // OLD:
        getParams: {
          p: 1,
          s: 'created_at-',
          f: {
          },
          pp: 20
        },
        selectedStates: [],
        print_date: '',
        assignedTo: '', // localStorage.getItem('userid'),
        doctors: [],
        doctorsPending: false,
        doctorsError: false,
        selectedDoctorId: null,
        showDoctorModal: false,
        listData: false,
        listError: false,
        listPagination: null,
        listPending: false,
        clientPreviousTasks: false,
        clientPreviousTasksError: false,
        clientPreviousTasksPending: true,
        waiting: true,
        editingTaskId: false,
        editingTask: {},
        waitForSave: false,
        openedTaskId: false,
        openedTaskEvaluation: '',
        updatedTask: {
          evaluation: '',
          state: '',
          client_id: false,
          include_result_to_email: true,
          dont_send_email: false
        },
        selected: '',
        clients: [],
        clientsPending: false,
        clientsError: false,
        state: '',
        openedClientTaskId: false
      }
    },
    mixins: [apiMixin],
    methods: {
      // OLD
      setPage (number) {
        this.getParams.p = number
        this.getDoctorsDayTasks()
      },
      getDoctorsDayTasks () {
        this.getContractualReports(this.getParams)
      },
      generate () {
        this.getGenerateContractualReports(this.generateParams)
      }
    },
    beforeMount () {
      this.getDoctorsDayTasks(this.generateContractualReports)
    },
    watch: {
      selectedDate (val) {
        if (val !== null) {
          this.generateParams.date = this.$moment(val).format('DD.MM.YYYY')
        }
      },
      generateContractualReportsDone (val) {
        if (val === true) {
          // console.log(this.generateContractualReports)
        }
      }
    },
    components: {
      PaginationComponent
      // TaskChangeDoctor,
      // TaskChangeState,
      // Datepicker
    },
    filters: {
      //
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

    .table th, .table td {
        padding: 1px;
    }

    .no-top-border {
        border-top: none;
    }

    .btn_line-heigh-1 {
        line-height: 1;
    }

</style>



// WEBPACK FOOTER //
// src/views/ContractualReporting/components/ContractualReporting.vue?58db6d9a